// "Jobs" on a maintenance task or a spare (Service package): the jobs that use it, one tap to open; on a task, one tap to make a job from it (management).
// No package: nothing is read and nothing is drawn. The row rules decide what this login sees.
import { useEffect, useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import { supabase } from '../lib/supabase'
import { jobRef, OPEN, isoDay, nextWorkday, defaultsFor } from './core'
import { S, Status } from './ui'
import { createJob, effectiveOf, errText } from './data'

export const LINK_KINDS = { mtask: { table: 'work_order_tasks', col: 'maintenance_task_id' }, inventory: { table: 'work_order_parts', col: 'inventory_id' } }

export default function ServiceJobLinks({ tableName, rowId, name }) {
  const { config, accountType } = useAuth()
  const kind = LINK_KINDS[tableName]
  const on = !!(config && config.service && config.service.on && kind && rowId)
  const [jobs, setJobs] = useState(null), [err, setErr] = useState(''), [busy, setBusy] = useState(false)
  useEffect(() => {
    if (!on) return
    let live = true
    ;(async () => {
      const mgr = !!config._companyView || accountType === 'company'   // the vessel's own people read the views (no hours, clock times or notes)
      const { data: links } = await supabase.from(!mgr && kind.table === 'work_order_tasks' ? 'work_order_tasks_crew' : kind.table).select('work_order_id').eq(kind.col, rowId).limit(100)
      const ids = [...new Set((links || []).map(l => l.work_order_id))]
      const { data } = ids.length ? await supabase.from(mgr ? 'work_orders' : 'work_orders_crew').select('id,job_no,title,status,scheduled_date').in('id', ids).order('created_at', { ascending: false }).limit(20) : { data: [] }
      if (live) setJobs(data || [])
    })().catch(() => { if (live) setJobs([]) })
    return () => { live = false }
  }, [on, rowId]) // eslint-disable-line
  if (!on || !jobs) return null
  const manager = !!config._companyView || accountType === 'company'
  const canMake = tableName === 'mtask' && manager && !jobs.some(j => OPEN.has(j.status))
  if (!jobs.length && !canMake) return null
  const go = id => { try { if (id) localStorage.setItem('hc_open_job', id); localStorage.setItem('hc_page', 'work_orders') } catch (e) {} window.dispatchEvent(new CustomEvent('hc:navigate', { detail: { page: 'work_orders' } })) }
  const make = async () => {
    setBusy(true); setErr('')
    try {
      const today = isoDay(Date.now() - new Date().getTimezoneOffset() * 6e4)
      const eff = await effectiveOf(config.id).catch(() => ({}))
      const d = defaultsFor({ title: name, clientId: config.id, history: [], effective: eff || {}, today })
      const j = await createJob({ client_id: config.id, title: name || 'Maintenance task', source: 'maintenance', technician_id: d.technician_id, scheduled_date: nextWorkday(today), lines: [{ text: name || 'Maintenance task', maintenance_task_id: rowId }] })
      go(j.id)
    } catch (e) { setErr(errText(e)); setBusy(false) }
  }
  return (
    <div data-service="job-links" style={{ margin: '0 0 10px', padding: '8px 10px', border: '1px solid var(--line)', borderRadius: 10 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
        <b style={{ fontSize: 12.5, color: 'var(--text)' }}>Jobs</b>
        {canMake && <button type="button" style={{ ...S.ghost, padding: '3px 10px', fontSize: 12 }} disabled={busy} onClick={make}>Create job</button>}
      </div>
      {err && <div style={S.err}>{err}</div>}
      {jobs.map(j => (
        <button type="button" key={j.id} onClick={() => go(j.id)} style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%', background: 'none', border: 'none', borderTop: '1px solid var(--line)', padding: '6px 0', marginTop: 4, cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit', color: 'var(--text)', fontSize: 12.5 }}>
          <span style={{ flex: 1 }}>{jobRef(j)} · {j.title}{j.scheduled_date ? ' · ' + j.scheduled_date : ''}</span><Status s={j.status} />
        </button>
      ))}
    </div>
  )
}
